import styled, { css } from 'styled-components';
import { system, FlexContainer, Text, textColors } from '@taxdown/piccolo-web';
import { stages } from 'Constants/stages';
import { DESKTOP_EXTRA_SMALL_WIDTH, DESKTOP_WIDTH, MOBILE_WIDTH } from 'Styles/variables/sizes';
import { ResultTypes } from 'Types/common';

const discardedStatus = {
  [stages.DISCARDED]: system.background.fds_sys_color_background_error_strong,
  [stages.DISCARDED_NO_RESPONSE]: system.background.fds_sys_color_background_error_strong,
  [stages.DISCARDED_ALREADY_FILED]: system.background.fds_sys_color_background_error_strong,
  [stages.DISCARDED_FREELANCER]: system.background.fds_sys_color_background_error_strong,
  [stages.DISCARDED_NOT_MANDATORY]: system.background.fds_sys_color_background_gradient_A,
  [stages.DISCARDED_NOT_WANT_TO_FILE]: system.background.fds_sys_color_background_error_strong,
  [stages.VALIDATION_REJECTED]: system.background.fds_sys_color_background_error_strong,
  [stages.DISCARDED_OTHER]: system.background.fds_sys_color_background_error_strong,
  [stages.DISCARDED_NOT_SUPPORTED]: system.background.fds_sys_color_background_error_strong,
};

const afterFlowStatus = {
  [stages.PENDING_MANUAL_MODIFICATIONS]: system.background.fds_sys_color_background_warning_strong,
  [stages.PENDING_AUTOMATIC_MODIFICATIONS]: system.background.fds_sys_color_background_gradient_B,
  [stages.FINISHED_NOT_SUCCESS]: system.background.fds_sys_color_background_warning_strong,
};

export const STATUS_TYPES = {
  [stages.MISSING_INFORMATION]: system.background.fds_sys_color_background_warning_strong,
  [stages.VALIDATION]: system.background.fds_sys_color_background_warning_strong,
  [stages.SUBMITTED_CHANGED_WAITING_USER_RESPONSE]:
    system.background.fds_sys_color_background_warning_strong,
  [stages.FILED]: system.background.fds_sys_color_background_gradient_A,
  [stages.FINISHED]: system.background.fds_sys_color_background_gradient_A,
  [stages.FINISHED_ACCEPTED]: system.background.fds_sys_color_background_gradient_B,
  [stages.FINISHED_PAYMENT_ISSUED]: system.background.fds_sys_color_background_warning_strong,
  [stages.FINISHED_TRANSFERRING]: system.background.fds_sys_color_background_gradient_B,
  [stages.SUBMITTED]: system.background.fds_sys_color_background_gradient_B,
  [stages.FINISHED_SUCCESS]: system.background.fds_sys_color_background_gradient_A,
  [stages.TAX_AGENCY_DEBT]: system.background.fds_sys_color_background_warning_strong,
  [stages.FILED_MANUAL]: system.background.fds_sys_color_background_gradient_B,
  [stages.FINISHED_AUTOMATIC_NOT_SUCCESS]:
    system.background.fds_sys_color_background_warning_strong,
  [stages.FINISHED_MANUAL_NOT_SUCCESS]: system.background.fds_sys_color_background_error_strong,
  [stages.FINISHED_MISSING_CLABE]: system.background.fds_sys_color_background_warning_strong,
  [stages.TAX_AGENCY_CLABE_ISSUED]: system.background.fds_sys_color_background_warning_strong,
  [stages.INVALID_SAT_CLABE]: system.background.fds_sys_color_background_warning_strong,
  [stages.AUTOMATIC_PAYMENT_FAILED]: system.background.fds_sys_color_background_warning_strong,
  ...discardedStatus,
  ...afterFlowStatus,
};

export const Title = styled(Text)`
  display: none;
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    display: block;
  }
  @media screen and (max-width: ${DESKTOP_WIDTH}) {
    display: block;
  }
`;

export const Content = styled(FlexContainer)`
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;

  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    height: auto;
  }
`;

export const TaxContainer = styled(FlexContainer)`
  border-radius: ${system.fds_sys_borderradius_L};
  border: 1px solid ${system.border.fds_sys_color_border_secondary};
  gap: ${({ theme: { reference } }) => reference.dimension_16};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    border: none;
    gap: ${({ theme: { reference } }) => reference.dimension_24};
  }
`;

export const TaxContent = styled(FlexContainer)<{
  $renderWizard: boolean;
  $isUserWithPreFiling: boolean;
  $hasMultipleFiling: boolean;
}>`
  border-bottom-left-radius: ${system.fds_sys_borderradius_L};
  border-bottom-right-radius: ${system.fds_sys_borderradius_L};
  ${({ $renderWizard }) => css`
    border-top-left-radius: ${$renderWizard ? '0' : system.fds_sys_borderradius_L};
    border-top-right-radius: ${$renderWizard ? '0' : system.fds_sys_borderradius_L};
  `}
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  background: ${({ isFull, stage, $isUserWithPreFiling, $hasMultipleFiling }) =>
    $isUserWithPreFiling
      ? STATUS_TYPES[stages.FILED]
      : $hasMultipleFiling
        ? STATUS_TYPES[stages.PENDING_AUTOMATIC_MODIFICATIONS]
        : STATUS_TYPES[stage]
          ? STATUS_TYPES[stage]
          : isFull
            ? 'linear-gradient(180deg, rgba(255, 199, 0, 0.03) 0%, rgba(255, 199, 0, 0.1) 100%)'
            : system.background.fds_sys_color_background_gradient_B};

  .tax-screen-title {
    width: 270px;
  }
  .tax-screen-subtitle {
    width: 400px;
    @media screen and (max-width: ${MOBILE_WIDTH}) {
      width: 315px;
    }
  }

  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    height: auto;
  }
`;

export const BannersContainer = styled(FlexContainer)`
  @media screen and (min-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    display: none;
  }
`;

export const ColorByResult = {
  [ResultTypes.toReturn]: textColors.success_strong,
  [ResultTypes.toPay]: textColors.danger_strong,
  [ResultTypes.equal]: textColors.grey,
};

export const AmountResolved = styled(Text)<{ $resultType: string }>`
  color: ${({ $resultType }) => ColorByResult[$resultType]};
`;
